import { alpha } from '@mui/material/styles';

/** Cool-gray scrollbar. Avoid warm paper `border.subtle` for thumbs. */
export default function getCoolScrollbarSx(theme) {
  const thumb = theme.palette.background.softHover;
  const thumbHover = alpha(theme.palette.text.primary, 0.28);

  return {
    scrollbarWidth: 'thin',
    scrollbarColor: `${thumb} transparent`,
    '&::-webkit-scrollbar': {
      width: 8,
      height: 8,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumb,
      borderRadius: 999,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbHover,
    },
  };
}
